import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useField } from '@unform/core';

type TVTextFieldProps = TextFieldProps & {
  name: string;
  calcular?: (novoTextoselect: string | undefined) => void;
};

// Função para formatar a string no padrão brasileiro
const formatInputToBRL = (input: string): string => {
  const numericOnly = input.replace(/\D/g, '');

  if (numericOnly.length <= 2) {
    return numericOnly;
  }

  const integerPart = numericOnly.slice(0, -2);
  const decimalPart = numericOnly.slice(-2);
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedInteger},${decimalPart}`;
};

export const VTextFieldNumberReal = forwardRef<HTMLInputElement, TVTextFieldProps>(
  ({ calcular, name, ...rest }, ref) => {
    const {
      fieldName,
      registerField,
      defaultValue,
      error,
      clearError,
    } = useField(name);

    const [value, setValue] = useState(
      defaultValue ? formatInputToBRL(String(defaultValue)) : ''
    );

    const inputRef = React.useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    useEffect(() => {
      registerField({
        name: fieldName,
        ref: inputRef.current!,
        getValue: () =>
          parseFloat(value.replace(/\./g, '').replace(',', '.')) || 0,
        setValue: (_, newValue) =>
          setValue(formatInputToBRL(String(newValue))),
        clearValue: () => setValue(''),
      });
    }, [registerField, fieldName, value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      const formattedValue = formatInputToBRL(inputValue);
      setValue(formattedValue);
      calcular?.(formattedValue);
      rest.onChange?.(e);
    };

    return (
      <TextField
        {...rest}
        error={!!error}
        helperText={error}
        value={value}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (error) clearError();
          rest.onKeyDown?.(e);
        }}
        inputRef={inputRef} // 🔥 agora aceita ref externo!
      />
    );
  }
);
